module.exports = __webpack_public_path__ + "img/pro-p-slider24.e688230e.jpg";